import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
// import store from '../../login/store'
export const getBookingFormSetting = createAsyncThunk('BookingFormSetting/GetBookingFormSetting', async (params) => {


  const response = await axios.post(' https://api.zasway.com:8443/BookingFormSetting/GetBookingFormSetting', params, { mode: 'cors' })

  return {
    params,
    data: response.data
  }
})
export const EditBookingForm = createAsyncThunk('BookingFormSetting/Update', async (BookingForm) => {

  const response = await axios.post(' https://api.zasway.com:8443/BookingFormSetting/Update', BookingForm, { mode: 'cors' })
  // , { dispatch, getState }
  // await dispatch(getData(getState().users.params))
  // await dispatch(getAllData())
  return response
})
export const addSetting = createAsyncThunk('/BookingExpenseType/Create', async (Booking) => {

  const response = await axios.post(' https://api.zasway.com:8443/BookingExpenseType/Create', Booking, { mode: 'cors' })

  return response
})
// Adding Location Address
export const addLocation = createAsyncThunk('/BookingExpenseType/addLocation', (Location) => {

  return { data: Location }
})
export const EditExpense = createAsyncThunk('BookingExpenseType/Update', async (Booking) => {

  const response = await axios.post(' https://api.zasway.com:8443/BookingExpenseType/Update', Booking, { mode: 'cors' })
  // , { dispatch, getState }
  // await dispatch(getData(getState().users.params))
  // await dispatch(getAllData())
  return response
})
export const GetExpenseTypeDetailByID = createAsyncThunk('BookingExpenseType/GetExpenseTypeDetailByID', async (Booking) => {
  //  
  const response = await axios.post(' https://api.zasway.com:8443/BookingExpenseType/GetExpenseTypeDetailByID', Booking, { mode: 'cors' })

  return response.data
})


export const resetExpenseTypeDetail = createAsyncThunk('BookingExpenseType/resetExpenseTypeDetail', async () => {

  return { data: [] }
})

export const deleteExpense = createAsyncThunk('BookingExpenseType/Delete', async (id) => {

  const response = await axios.post(' https://api.zasway.com:8443/BookingExpenseType/Delete', id, { mode: 'cors' })
  return response
})

// ** Additional Charges Actions
export const getAdditionalChargesData = createAsyncThunk('AdditionalCharges/GetTableSummary', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/AdditionalCharges/GetTableSummary', params, { mode: 'cors' })
  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const addAdditionalCharge = createAsyncThunk('AdditionalCharges/Create', async (data) => {
  const response = await axios.post(' https://api.zasway.com:8443/AdditionalCharges/Create', data, { mode: 'cors' })
  return response
})

export const editAdditionalCharge = createAsyncThunk('AdditionalCharges/Update', async (data) => {
  const response = await axios.post(' https://api.zasway.com:8443/AdditionalCharges/Update', data, { mode: 'cors' })
  return response
})

export const getAdditionalChargeById = createAsyncThunk('AdditionalCharges/GetAdditionalChargeByID', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/AdditionalCharges/GetAdditionalChargeByID', params, { mode: 'cors' })
  return response.data
})

export const deleteAdditionalCharge = createAsyncThunk('AdditionalCharges/Delete', async (id) => {
  const response = await axios.post(' https://api.zasway.com:8443/AdditionalCharges/Delete', id, { mode: 'cors' })
  return response
})

export const resetAdditionalCharge = createAsyncThunk('AdditionalCharges/Reset', async () => {
  return { data: [] }
})
export const getData = createAsyncThunk('BookingExpenseType/GetExpenseTypeLists', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/BookingExpenseType/GetExpenseTypeLists', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data || response.data,
    allData: response.data.allData || response.data,
    totalPages: response.data.total || 1
  }
})

export const getTaxList = createAsyncThunk('setting/getTaxList', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetTaxList', params, { mode: 'cors' })
  return response.data
})

export const getChargeTypeList = createAsyncThunk('setting/getChargeTypeList', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetChargeTypeList', params, { mode: 'cors' })
  return response.data
})

export const SettingSlice = createSlice({
  name: 'setting',
  initialState: {
    data: [],
    formSettingData: [],
    total: 1,
    params: {},
    formSettingparams: {},
    allData: [],
    selectedUser: null,
    selectedExpense: [],
    addressLocation: [],
    additionalCharges: [],
    selectedAdditionalCharge: [],
    totalAdditionalCharges: 1
  },
  reducers: {},
  extraReducers: builder => {
    builder
      // .addCase(getAllData.fulfilled, (state, action) => {
      //   state.allData = action.payload
      // })
      .addCase(getData.fulfilled, (state, action) => {
        //   
        state.allData = action.payload.allData
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(GetExpenseTypeDetailByID.fulfilled, (state, action) => {
        //  
        state.selectedExpense = action.payload
      })
      .addCase(resetExpenseTypeDetail.fulfilled, (state, action) => {
        //  

        state.selectedExpense = action.payload.data
      })
      .addCase(getBookingFormSetting.fulfilled, (state, action) => {
        //   
        state.formSettingData = action.payload.data
        //  state.data = action.payload.data
        state.formSettingparams = action.payload.params
      })
      .addCase(addLocation.fulfilled, (state, action) => {

        state.addressLocation = action.payload.data

      })
      .addCase(getAdditionalChargesData.fulfilled, (state, action) => {
        state.additionalCharges = action.payload.data
        state.totalAdditionalCharges = action.payload.totalPages
      })
      .addCase(getAdditionalChargeById.fulfilled, (state, action) => {
        state.selectedAdditionalCharge = action.payload
      })
      .addCase(resetAdditionalCharge.fulfilled, (state, action) => {
        state.selectedAdditionalCharge = action.payload.data
      })

  }
})
export default SettingSlice.reducer